export const translations = {
  en: {
    dashboard: {
      loading: 'Loading...',
      welcome: 'Welcome to Valiyou',
      welcomeDescription: 'To get started, please create your club profile',
      enterClubName: 'Enter your club name',
      creating: 'Creating...',
      createClub: 'Create Club',
      valuations: 'Dashboard',
      createValuation: 'New Valuation',
      valuationOverTime: 'Valuation Over Time',
      noValuations: 'No valuations yet',
      noValuationsDescription: 'Get started by creating your first valuation.',
      createFirstValuation: 'Create your first valuation',
      lastEdited: 'Last Edited',
      salesValue: 'Sales Value',
      mediaValue: 'Media Value',
      qualityMultiplier: 'Quality Multiplier',
    },
    valuationForm: {
      // Header
      newValuation: 'New Valuation',
      editValuation: 'Edit Valuation',
      createDescription: 'Enter data below to calculate the total attention value',
      editDescription: 'Update the valuation data below',

      // Test Data
      loadExamples: 'Examples',
      footballExample: 'Football Example',
      basketballExample: 'Basketball Example',
      multilineExample: 'Multiline Example',
      resetForm: 'Reset Form',

      // Date
      valuationDate: 'Valuation Date',
      date: 'Date',

      // Sales Section
      salesValue: 'Sales Value',
      hq: 'HQ',
      mq: 'MQ',
      subj: 'SUBJ',
      merchandiseRevenue: 'Merchandise Revenue',
      matchdayRevenue: 'Matchday Revenue',

      // Player Sales
      playerSalesValue: 'Player Sales Value',
      addPlayerSale: '+ Add Player Sale',
      playerName: 'Player Name',
      enterPlayerName: 'Enter player name',
      saleValue: 'Sale Value',
      noPlayerSales: 'No player sales added yet. Click "+ Add Player Sale" to add one.',
      totalPlayerSalesValue: 'Total Player Sales Value:',
      player: 'Player',

      // Media Value
      mediaValue: 'Media Value',

      // TV
      tv: 'TV',
      tvDuration: 'TV Duration (minutes)',
      tvSizeCategory: 'TV Size Category',
      tvSizeSmall: 'S - Small (≤1%)',
      tvSizeMedium: 'M - Medium (~1-5%)',
      tvSizeLarge: 'L - Large (~5-15%)',
      tvSizeXLarge: 'XL - Extra Large (>15%)',
      tvCpm: 'TV CPM',
      tvViewers: 'TV Viewers',

      // Web TV
      webTv: 'Web TV / Streaming',
      webTvViews: 'Web TV Views',
      webTvCpm: 'Web TV CPM',

      // PR
      pr: 'PR / Earned Media',
      prReach: 'PR Reach',
      prCpm: 'PR CPM',

      // Digital
      digital: 'Digital Display',
      digitalImpressions: 'Digital Impressions',
      digitalCpm: 'Digital CPM',

      // Social Media
      social: 'Social Media',
      socialFollowers: 'SoMe Followers',
      socialFollowersCpm: 'SoMe Followers CPM',
      socialImpressions: 'SoMe Impressions',
      socialImpressionsCpm: 'SoMe Impressions CPM',
      socialEngagements: 'SoMe Engagements',
      socialCpm: 'SoMe Engagements CPM',

      // Match & Hospitality
      matchHospitality: 'Match & Hospitality',
      matchAttendance: 'Attendance',
      attendanceCpm: 'Attendance CPM',
      hospitalityGuests: 'VIP Guests',
      hospitalityValuePerGuest: 'Hospitality Value per Guest',

      // Brand Indicators
      brandValueIndicators: 'Brand Value Indicators',
      popularity: 'Popularity:',
      popularityHelp: 'General public awareness and appeal',
      csr: 'CSR:',
      csrHelp: 'Corporate Social Responsibility alignment',
      culture: 'Culture:',
      cultureHelp: 'Cultural fit and relevance',
      fansLoyalty: 'Fans/Loyalty:',
      fansLoyaltyHelp: 'Fan base engagement and loyalty strength',

      // Buttons
      deleteValuation: 'Delete',
      saveValuation: 'Save Valuation',
      updateValuation: 'Update Valuation',
      saving: 'Saving...',

      // Live Calculation
      liveCalculation: 'Live Calculation',
      salesValueBreakdown: 'Sales Value Breakdown',
      playerSales: 'Player Sales:',
      merchandiseRevenueShort: 'Merchandise Revenue:',
      matchdayRevenueShort: 'Matchday Revenue:',
      totalSales: 'Total Sales:',
      mediaValueBreakdown: 'Media Value Breakdown',
      tvShort: 'TV:',
      webTvShort: 'Web TV:',
      prShort: 'PR:',
      digitalShort: 'Digital:',
      socialShort: 'Social:',
      influencersShort: 'Influencers:',
      attendanceShort: 'Attendance:',
      hospitalityShort: 'Hospitality:',
      totalMedia: 'Total Media:',
      qualitativeMultiplier: 'Qualitative Multiplier',
      finalTotalValue: 'Final Total Value',

      // Errors
      errorOccurred: 'An error occurred',
    },
    valuationDetail: {
      // Loading and Error
      loading: 'Loading...',
      notFound: 'Valuation not found',

      // Navigation
      backToDashboard: '← Back to Dashboard',
      exportPdf: 'Export PDF',
      edit: 'Edit',
      delete: 'Delete',

      // Delete Confirmation Modal
      deleteConfirmTitle: 'Delete Valuation',
      deleteConfirmMessage:
        'Are you sure you want to delete this valuation? This action cannot be undone.',
      deleteConfirmButton: 'Delete',
      deleteCancelButton: 'Cancel',

      // Print Header
      valuationReport: 'Valuation Report',

      // Page Header
      valuationDetails: 'Valuation Details',

      // Summary Cards
      totalValue: 'Total Attention Valuation',
      salesValue: 'Sales Value',
      mediaValue: 'Media Value',
      multiplier: 'Multiplier',

      // Sales Section (reuse from form)
      merchandiseRevenue: 'Merchandise Revenue',
      matchdayRevenue: 'Matchday Revenue',

      // Player Sales
      playerSalesValue: 'Player Sales Value',
      totalPlayerSalesValue: 'Total Player Sales Value:',
      noPlayerSales: 'No player sales recorded for this valuation.',

      // Multi-entry media lines
      channelTotal: 'Total:',

      // Media Subsections
      tv: 'TV',
      duration: 'Duration',
      minutes: 'minutes',
      sizeCategory: 'Size Category',
      cpm: 'CPM',
      viewers: 'Viewers',

      webTv: 'Web TV',
      views: 'Views',

      pr: 'PR',
      reach: 'Reach',

      digital: 'Digital',
      impressions: 'Impressions',

      social: 'Social',
      socialFollowers: 'SoMe Followers',
      socialImpressions: 'SoMe Impressions',
      socialEngagements: 'SoMe Engagements',

      influencers: 'Influencers',
      influencerReach: 'Influencer Reach',
      influencerImpressions: 'Influencer Impressions',
      influencerEngagements: 'Influencer Engagements',

      matchHospitality: 'Match & Hospitality',
      attendance: 'Attendance',
      attendanceCpm: 'Attendance CPM',
      hospitalityGuests: 'VIP Guests',
      valuePerGuest: 'Value per Guest',

      // Brand Section
      brandValueIndicators: 'Brand Value Indicators',
      popularity: 'Popularity',
      csr: 'CSR',
      culture: 'Culture',
      fansLoyalty: 'Fans/Loyalty',
    },
    profile: {
      title: 'Profile',
      name: 'Name',
      namePlaceholder: 'Your full name',
      firstName: 'First Name',
      surname: 'Surname',
      language: 'Language',
      email: 'Email',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      updating: 'Updating...',
      updateProfile: 'Update Profile',
      personalInfo: 'Personal Information',
      security: 'Security',
    },
    settings: {
      title: 'Settings',
      subtitle: 'Manage your club settings',
      logo: 'Logo',
      changeLogo: 'Change Logo',
      removeLogo: 'Remove Logo',
      logoUploading: 'Uploading...',
      uploadLogo: 'Upload Logo',
      logoUploadError: 'Failed to upload logo',
      clubSettings: 'Club Settings',
      address: 'Address',
      clubName: 'Club Name',
      street: 'Street',
      houseNumber: 'No',
      postalCode: 'Postal Code',
      city: 'City',
      country: 'Country',
      baseCurrency: 'Base Currency',
      defaultBrandIndicators: 'Default Brand Value Indicators',
      defaultBrandIndicatorsHelp: 'These values will be used as initial values for new valuations',
      defaultPopularity: 'Default Popularity',
      defaultCsr: 'Default CSR',
      defaultCulture: 'Default Culture',
      defaultFansLoyalty: 'Default Fans/Loyalty',
      settingsUpdated: 'Settings updated successfully',
      errorUpdating: 'Failed to update settings',
      saving: 'Saving...',
      saveSettings: 'Save Settings',
    },
    users: {
      // Delete Confirmation Modal
      removeUserTitle: 'Remove User',
      removeUserMessage: 'Are you sure you want to remove {email} from the team?',
      cancelInvitationTitle: 'Cancel Invitation',
      cancelInvitationMessage: 'Are you sure you want to cancel the invitation for {email}?',
      removeButton: 'Remove',
      cancelButton: 'Cancel',
    },
    demoMode: {
      title: 'Not available in Demo Mode',
      message:
        'This feature is not available in demo mode.\n\nTo save or create content, please upgrade to a paid plan.',
      viewPlans: 'View Plans',
      close: 'Close',
    },
    permissionDenied: {
      title: 'Permission Denied',
      message:
        'You do not have permission to perform this action.\n\nPlease contact your administrator to request access.',
      close: 'Close',
    },
    common: {
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      back: 'Back',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
    },
  },
  da: {
    dashboard: {
      loading: 'Indlæser...',
      welcome: 'Velkommen til Valiyou',
      welcomeDescription: 'For at komme i gang, skal du oprette din klubprofil',
      enterClubName: 'Indtast dit klubnavn',
      creating: 'Opretter...',
      createClub: 'Opret Klub',
      valuations: 'Dashboard',
      createValuation: 'Ny Værdiansættelse',
      valuationOverTime: 'Værdiansættelse Over Tid',
      noValuations: 'Ingen værdiansættelser endnu',
      noValuationsDescription: 'Kom i gang ved at oprette din første værdiansættelse.',
      createFirstValuation: 'Opret din første værdiansættelse',
      lastEdited: 'Sidst Redigeret',
      salesValue: 'Salgsværdi',
      mediaValue: 'Medieværdi',
      qualityMultiplier: 'Kvalitetsmultiplikator',
    },
    valuationForm: {
      // Header
      newValuation: 'Ny Værdiansættelse',
      editValuation: 'Rediger Værdiansættelse',
      createDescription: 'Indtast data nedenfor for at beregne den samlede opmærksomhedsværdi',
      editDescription: 'Opdater værdiansættelsesdata nedenfor',

      // Test Data
      loadExamples: 'Indlæs Eksempler',
      footballExample: 'Fodbold Eksempel',
      basketballExample: 'Basketball Eksempel',
      multilineExample: 'Multilinje Eksempel',
      resetForm: 'Nulstil Formular',

      // Date
      valuationDate: 'Værdiansættelsesdato',
      date: 'Dato',

      // Sales Section
      salesValue: 'Salgsværdi',
      hq: 'HQ',
      mq: 'MQ',
      subj: 'SUBJ',
      merchandiseRevenue: 'Merchandise-omsætning',
      matchdayRevenue: 'Kampdag-omsætning',

      // Player Sales
      playerSalesValue: 'Spillersalgsværdi',
      addPlayerSale: '+ Tilføj Spillersalg',
      playerName: 'Spillernavn',
      enterPlayerName: 'Indtast spillernavn',
      saleValue: 'Salgsværdi',
      noPlayerSales:
        'Ingen spillersalg tilføjet endnu. Klik på "+ Tilføj Spillersalg" for at tilføje et.',
      totalPlayerSalesValue: 'Samlet Spillersalgsværdi:',
      player: 'Spiller',

      // Media Value
      mediaValue: 'Medieværdi',

      // TV
      tv: 'TV',
      tvDuration: 'TV Varighed (minutter)',
      tvSizeCategory: 'TV Størrelse Kategori',
      tvSizeSmall: 'S - Lille (≤1%)',
      tvSizeMedium: 'M - Mellem (~1-5%)',
      tvSizeLarge: 'L - Stor (~5-15%)',
      tvSizeXLarge: 'XL - Ekstra Stor (>15%)',
      tvCpm: 'TV CPM',
      tvViewers: 'TV Seere',

      // Web TV
      webTv: 'Web TV / Streaming',
      webTvViews: 'Web TV Visninger',
      webTvCpm: 'Web TV CPM',

      // PR
      pr: 'PR / Earned Media',
      prReach: 'PR Rækkevidde',
      prCpm: 'PR CPM',

      // Digital
      digital: 'Digital Display',
      digitalImpressions: 'Digitale Visninger',
      digitalCpm: 'Digital CPM',

      // Social Media
      social: 'Sociale Medier',
      socialFollowers: 'SoMe Følgere',
      socialFollowersCpm: 'SoMe Følgere CPM (kr)',
      socialImpressions: 'SoMe Visninger',
      socialImpressionsCpm: 'SoMe Visninger CPM (kr)',
      socialEngagements: 'SoMe Engagementer',
      socialCpm: 'SoMe Engagementer CPM (kr)',

      // Match & Hospitality
      matchHospitality: 'Kamp & Hospitality',
      matchAttendance: 'Tilskuere',
      attendanceCpm: 'Tilskuer CPM',
      hospitalityGuests: 'VIP Gæster',
      hospitalityValuePerGuest: 'Hospitality Værdi per Gæst',

      // Brand Indicators
      brandValueIndicators: 'Brand Værdi Indikatorer',
      popularity: 'Popularitet:',
      popularityHelp: 'Generel offentlig bevidsthed og appel',
      csr: 'CSR:',
      csrHelp: 'Virksomhedernes Sociale Ansvar tilpasning',
      culture: 'Kultur:',
      cultureHelp: 'Kulturel pasform og relevans',
      fansLoyalty: 'Fans/Loyalitet:',
      fansLoyaltyHelp: 'Fanbase engagement og loyalitetsstyrke',

      // Buttons
      deleteValuation: 'Slet',
      saveValuation: 'Gem Værdiansættelse',
      updateValuation: 'Opdater Værdiansættelse',
      saving: 'Gemmer...',

      // Live Calculation
      liveCalculation: 'Live Beregning',
      salesValueBreakdown: 'Salgsværdi Opdeling',
      playerSales: 'Spillersalg:',
      merchandiseRevenueShort: 'Merchandise-omsætning:',
      matchdayRevenueShort: 'Kampdag-omsætning:',
      totalSales: 'Samlet Salg:',
      mediaValueBreakdown: 'Medieværdi Opdeling',
      tvShort: 'TV:',
      webTvShort: 'Web TV:',
      prShort: 'PR:',
      digitalShort: 'Digital:',
      socialShort: 'Social:',
      influencersShort: 'Influencers:',
      attendanceShort: 'Tilskuere:',
      hospitalityShort: 'Hospitality:',
      totalMedia: 'Samlet Medier:',
      qualitativeMultiplier: 'Kvalitativ Multiplikator',
      finalTotalValue: 'Endelig Totalværdi',

      // Errors
      errorOccurred: 'Der opstod en fejl',
    },
    valuationDetail: {
      // Loading and Error
      loading: 'Indlæser...',
      notFound: 'Værdiansættelse ikke fundet',

      // Navigation
      backToDashboard: '← Tilbage til Dashboard',
      exportPdf: 'Eksporter PDF',
      edit: 'Rediger',
      delete: 'Slet',

      // Delete Confirmation Modal
      deleteConfirmTitle: 'Slet Værdiansættelse',
      deleteConfirmMessage:
        'Er du sikker på at du vil slette denne værdiansættelse? Denne handling kan ikke fortrydes.',
      deleteConfirmButton: 'Slet',
      deleteCancelButton: 'Annuller',

      // Print Header
      valuationReport: 'Værdiansættelsesrapport',

      // Page Header
      valuationDetails: 'Værdiansættelsesdetaljer',

      // Summary Cards
      totalValue: 'Total Attention Værdiansættelse',
      salesValue: 'Salgsværdi',
      mediaValue: 'Medieværdi',
      multiplier: 'Multiplikator',

      // Sales Section
      merchandiseRevenue: 'Merchandise-omsætning',
      matchdayRevenue: 'Kampdag-omsætning',

      // Player Sales
      playerSalesValue: 'Spillersalgsværdi',
      totalPlayerSalesValue: 'Samlet Spillersalgsværdi:',
      noPlayerSales: 'Ingen spillersalg registreret for denne værdiansættelse.',

      // Multi-entry media lines
      channelTotal: 'I alt:',

      // Media Subsections
      tv: 'TV',
      duration: 'Varighed',
      minutes: 'minutter',
      sizeCategory: 'Størrelse Kategori',
      cpm: 'CPM',
      viewers: 'Seere',

      webTv: 'Web TV',
      views: 'Visninger',

      pr: 'PR',
      reach: 'Rækkevidde',

      digital: 'Digital',
      impressions: 'Visninger',

      social: 'Social',
      socialFollowers: 'SoMe Følgere',
      socialImpressions: 'SoMe Visninger',
      socialEngagements: 'SoMe Engagementer',

      influencers: 'Influencers',
      influencerReach: 'Influencer Rækkevidde',
      influencerImpressions: 'Influencer Visninger',
      influencerEngagements: 'Influencer Engagementer',

      matchHospitality: 'Kamp & Hospitality',
      attendance: 'Tilskuere',
      attendanceCpm: 'Tilskuer CPM',
      hospitalityGuests: 'VIP Gæster',
      valuePerGuest: 'Værdi per Gæst',

      // Brand Section
      brandValueIndicators: 'Brand Værdi Indikatorer',
      popularity: 'Popularitet',
      csr: 'CSR',
      culture: 'Kultur',
      fansLoyalty: 'Fans/Loyalitet',
    },
    profile: {
      title: 'Profil',
      name: 'Navn',
      namePlaceholder: 'Dit fulde navn',
      firstName: 'Fornavn',
      surname: 'Efternavn',
      language: 'Sprog',
      email: 'Email',
      newPassword: 'Ny Adgangskode',
      confirmPassword: 'Bekræft Adgangskode',
      updating: 'Opdaterer...',
      updateProfile: 'Opdater Profil',
      personalInfo: 'Personlige Oplysninger',
      security: 'Sikkerhed',
    },
    settings: {
      title: 'Indstillinger',
      subtitle: 'Administrer dine klubindstillinger',
      logo: 'Logo',
      changeLogo: 'Skift Logo',
      removeLogo: 'Fjern Logo',
      logoUploading: 'Uploader...',
      uploadLogo: 'Upload Logo',
      logoUploadError: 'Kunne ikke uploade logo',
      clubSettings: 'Klubindstillinger',
      address: 'Adresse',
      clubName: 'Klubnavn',
      street: 'Vej',
      houseNumber: 'Nr',
      postalCode: 'Postnummer',
      city: 'By',
      country: 'Land',
      baseCurrency: 'Basisvaluta',
      defaultBrandIndicators: 'Standard Brand Værdi Indikatorer',
      defaultBrandIndicatorsHelp: 'Disse værdier bruges som startværdier for nye værdiansættelser',
      defaultPopularity: 'Standard Popularitet',
      defaultCsr: 'Standard CSR',
      defaultCulture: 'Standard Kultur',
      defaultFansLoyalty: 'Standard Fans/Loyalitet',
      settingsUpdated: 'Indstillinger opdateret',
      errorUpdating: 'Kunne ikke opdatere indstillinger',
      saving: 'Gemmer...',
      saveSettings: 'Gem Indstillinger',
    },
    users: {
      // Delete Confirmation Modal
      removeUserTitle: 'Fjern Bruger',
      removeUserMessage: 'Er du sikker på at du vil fjerne {email} fra teamet?',
      cancelInvitationTitle: 'Annuller Invitation',
      cancelInvitationMessage: 'Er du sikker på at du vil annullere invitationen til {email}?',
      removeButton: 'Fjern',
      cancelButton: 'Annuller',
    },
    demoMode: {
      title: 'Ikke tilgængelig i Demo Mode',
      message:
        'Denne funktion er ikke tilgængelig i demo mode.\n\nFor at gemme eller oprette indhold, skal du opgradere til en betalt plan.',
      viewPlans: 'Se Planer',
      close: 'Luk',
    },
    permissionDenied: {
      title: 'Adgang Nægtet',
      message:
        'Du har ikke tilladelse til at udføre denne handling.\n\nKontakt venligst din administrator for at anmode om adgang.',
      close: 'Luk',
    },
    common: {
      loading: 'Indlæser...',
      error: 'Fejl',
      save: 'Gem',
      cancel: 'Annuller',
      delete: 'Slet',
      edit: 'Rediger',
      back: 'Tilbage',
      close: 'Luk',
      yes: 'Ja',
      no: 'Nej',
    },
  },
};

export type Locale = 'en' | 'da';

export function getTranslation(locale: Locale) {
  return translations[locale];
}
